"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Legend["default"];
  }
});
var _Legend = _interopRequireDefault(require("./Legend"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }